var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Typography } from "@uigovpe/components";
import { useState } from "react";
var buttonStyle = {
    alignItems: "stretch",
    background: "#FFFFFF",
    border: "1px solid #D1D5DB",
    borderRadius: 4,
    cursor: "pointer",
    display: "flex",
    minWidth: 0,
    overflow: "hidden",
    padding: 0,
    textAlign: "left",
    width: "100%",
};
var badgeWrapperStyle = {
    alignItems: "center",
    borderRight: "1px solid #D1D5DB",
    display: "flex",
    flexShrink: 0,
    justifyContent: "center",
    padding: "8px 10px",
};
var badgeStyle = {
    alignItems: "center",
    background: "#111827",
    borderRadius: 2,
    color: "#FFFFFF",
    display: "flex",
    fontSize: 9,
    fontWeight: 700,
    justifyContent: "center",
    letterSpacing: 0.3,
    lineHeight: 1,
    minHeight: 22,
    minWidth: 28,
    padding: "4px 3px",
};
var contentStyle = {
    alignItems: "center",
    display: "flex",
    flex: 1,
    gap: 8,
    justifyContent: "space-between",
    minWidth: 0,
    padding: "8px 10px 8px 12px",
};
var textBlockStyle = {
    display: "grid",
    gap: 1,
    minWidth: 0,
};
var fileNameStyle = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
};
var menuStyle = {
    alignItems: "center",
    color: "#6B7280",
    display: "flex",
    flexShrink: 0,
};
var getExtension = function (fileName) {
    var parts = fileName.split(".");
    var extension = parts.length > 1 ? parts.pop() : undefined;
    if (!extension) {
        return "ARQ";
    }
    return extension.toUpperCase().slice(0, 4);
};
export var formatFileSize = function (bytes) {
    if (bytes == null || !Number.isFinite(bytes) || bytes < 0) {
        return null;
    }
    if (bytes < 1024) {
        return "".concat(bytes, " b");
    }
    var kilobytes = bytes / 1024;
    if (kilobytes < 1024) {
        return "".concat(Math.round(kilobytes), " kb");
    }
    var megabytes = kilobytes / 1024;
    return "".concat(megabytes.toFixed(megabytes >= 10 ? 0 : 1).replace(".", ","), " mb");
};
export var readFileSizeFromMetadata = function (metadata) {
    var _a, _b;
    if (!metadata) {
        return null;
    }
    var candidate = (_b = (_a = metadata.size) !== null && _a !== void 0 ? _a : metadata.fileSize) !== null && _b !== void 0 ? _b : metadata.contentLength;
    if (typeof candidate === "number" && Number.isFinite(candidate)) {
        return candidate;
    }
    if (typeof candidate === "string" && candidate.trim() !== "") {
        var parsed = Number(candidate);
        if (Number.isFinite(parsed)) {
            return parsed;
        }
    }
    return null;
};
export var ConsultationFileButton = function (_a) {
    var fileName = _a.fileName, filePath = _a.filePath, fileSizeBytes = _a.fileSizeBytes, onOpen = _a.onOpen;
    var extension = getExtension(fileName);
    var formattedSize = formatFileSize(fileSizeBytes);
    var metaLabel = formattedSize
        ? "".concat(extension, " \u2022 ").concat(formattedSize)
        : extension;
    var _b = useState(false), opening = _b[0], setOpening = _b[1];
    var handleOpen = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (opening) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 4, 5]);
                    setOpening(true);
                    if (!onOpen) return [3 /*break*/, 3];
                    return [4 /*yield*/, onOpen()];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
                case 3:
                    if (filePath) {
                        window.open(filePath, "_blank", "noopener,noreferrer");
                    }
                    return [3 /*break*/, 5];
                case 4:
                    setOpening(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("button", __assign({ "aria-label": "Abrir arquivo ".concat(fileName), disabled: opening, onClick: function () { return void handleOpen(); }, style: buttonStyle, title: fileName, type: "button" }, { children: [_jsx("div", __assign({ style: badgeWrapperStyle }, { children: _jsx("span", __assign({ style: badgeStyle }, { children: extension })) })), _jsxs("div", __assign({ style: contentStyle }, { children: [_jsxs("div", __assign({ style: textBlockStyle }, { children: [_jsx(Typography, __assign({ fontWeight: "medium", size: "sm", style: fileNameStyle }, { children: fileName })), _jsx(Typography, __assign({ size: "xs", style: { color: "#6B7280", lineHeight: 1.2 } }, { children: opening ? "Abrindo..." : metaLabel }))] })), _jsx("span", __assign({ "aria-hidden": "true", style: menuStyle }, { children: _jsx(MoreHorizIcon, { fontSize: "small" }) }))] }))] })));
};
